export const ninetiesTimeline = [
  {
    year: "1990",
    topic: "都市文艺与商业娱乐并行",
    films: ["阿飞正传", "赌侠", "表姐你好嘢"],
    note: "类型片市场稳定，同时作者风格的文艺片开始受到关注，两种方向同时生长。",
  },
  {
    year: "1991",
    topic: "动作与喜剧全面开花",
    films: ["纵横四海", "黄飞鸿", "逃学威龙"],
    note: "功夫、枪战与校园喜剧同时走红，题材的边界被不断拓宽。",
  },
  {
    year: "1992",
    topic: "古装武侠热度走高",
    films: ["新龙门客栈", "笑傲江湖之东方不败", "审死官"],
    note: "旧题材被重新包装，武侠与喜剧两种语言开始频繁互借。",
  },
  {
    year: "1993",
    topic: "古装喜剧与功夫片齐飞",
    films: ["唐伯虎点秋香", "方世玉", "白发魔女传"],
    note: "密集的笑料与熟练的动作设计，成为这一年不少作品的共同标签。",
  },
  {
    year: "1994",
    topic: "作者风格走向成熟",
    films: ["东邪西毒", "重庆森林", "国产凌凌漆"],
    note: "影像与叙事更个人化，港片在商业化之外多了一层作者电影的气质。",
  },
  {
    year: "1995",
    topic: "神话喜剧与爱情叙事",
    films: ["大话西游", "回魂夜", "堕落天使"],
    note: "把神话、喜剧与爱情糅在一起，情感表达比以往更含蓄绵长。",
  },
  {
    year: "1996",
    topic: "都市情感与市井题材",
    films: ["甜蜜蜜", "古惑仔之人在江湖", "食神"],
    note: "视线从江湖转向普通人的日常，移民、谋生与情感成为常见主题。",
  },
  {
    year: "1997",
    topic: "时代节点，情感与喜剧并存",
    films: ["春光乍泄", "97家有喜事", "一个字头的诞生"],
    note: "在特殊的时间节点上，作品既回望过去，也尝试用新的方式讲老故事。",
  },
  {
    year: "1998",
    topic: "特效武侠与文艺片并置",
    films: ["风云雄霸天下", "玻璃之城", "暗花"],
    note: "电脑特效开始进入武侠题材，同时现实题材的文艺片依旧稳定。",
  },
  {
    year: "1999",
    topic: "千禧年前的类型转型",
    films: ["喜剧之王", "暗战", "千言万语"],
    note: "在世纪末的氛围里，类型片开始寻找新的表达，为之后的转型埋下伏笔。",
  },
];